import React from "react";

var CancelIcon = function CancelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.828 12l4.586-4.586a2 2 0 1 0-2.828-2.828L12 9.172 7.414 4.586a2 2 0 1 0-2.828 2.828L9.172 12l-4.586 4.586a2 2 0 1 0 2.828 2.828L12 14.828l4.586 4.586c.39.391.902.586 1.414.586s1.024-.195 1.414-.586a2 2 0 0 0 0-2.828z"
  }));
};

CancelIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
CancelIcon.defaultProps.solid = true;
export default CancelIcon;